import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";

export const PostCreazioneDatiCongelamento = ({ lotto, metodo, form, setForm, saving, onConferma }) => {
  const totale = Number(lotto?.quantita_preparata);
  const haTotale = lotto?.quantita_preparata != null && Number.isFinite(totale) && totale > 0;
  const quantita = Number(String(form.quantita_parziale || "").replace(",", "."));
  const parzialeValida = !form.solo_parte || (quantita > 0 && quantita < totale);
  const quantitaValida = haTotale ? parzialeValida : quantita > 0;
  const azione = metodo === "abbattitore" ? "Abbatti" : "Congela";

  return (
    <div className="space-y-4" data-testid="post-creazione-dati-congelamento">
      <div className="space-y-1.5">
        <Label htmlFor="post-congela-data">{metodo === "abbattitore" ? "Data abbattimento" : "Data congelamento"}</Label>
        <Input id="post-congela-data" type="date" value={form.data}
          onChange={event => setForm(prev => ({ ...prev, data: event.target.value }))} data-testid="post-congela-data" />
      </div>

      {haTotale ? (
        <div className="space-y-2" data-testid="post-congela-quantita-totale">
          <p className="text-sm">Quantità del lotto: <strong>{totale} {lotto.unita_misura || "kg"}</strong></p>
          <button type="button" className="text-sm font-semibold text-primary underline underline-offset-2"
            onClick={() => setForm(prev => ({ ...prev, solo_parte: !prev.solo_parte,
              quantita_parziale: prev.solo_parte ? String(totale) : "" }))}
            data-testid="post-congela-solo-parte">
            {form.solo_parte ? "Conserva tutto il lotto" : "Conserva solo una parte"}
          </button>
          {form.solo_parte && (
            <div className="space-y-1">
              <Label htmlFor="post-congela-quantita">Quantità da {azione.toLowerCase()} ({lotto.unita_misura || "kg"})</Label>
              <Input id="post-congela-quantita" type="text" inputMode="decimal" value={form.quantita_parziale}
                onChange={event => setForm(prev => ({ ...prev, quantita_parziale: event.target.value }))}
                data-testid="post-congela-quantita" />
              {!parzialeValida && form.quantita_parziale && (
                <p className="text-xs text-amber-700" role="alert" data-testid="post-congela-quantita-avviso">Inserisci una quantità inferiore a {totale} {lotto.unita_misura || "kg"}.</p>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="space-y-1">
          <Label htmlFor="post-congela-quantita">Quantità da {azione.toLowerCase()} ({lotto?.unita_misura || "kg"})</Label>
          <Input id="post-congela-quantita" type="text" inputMode="decimal" value={form.quantita_parziale}
            onChange={event => setForm(prev => ({ ...prev, quantita_parziale: event.target.value }))}
            data-testid="post-congela-quantita" />
        </div>
      )}

      <div className="space-y-1.5">
        <Label htmlFor="post-congela-mesi">{metodo === "abbattitore" ? "Validità dopo abbattimento" : "Durata in congelatore"}</Label>
        <div className="flex items-center gap-2">
          <Input id="post-congela-mesi" type="number" min="1" max="12" className="w-24" value={form.mesi}
            onChange={event => setForm(prev => ({ ...prev, mesi: event.target.value, data_scadenza_custom: "" }))}
            data-testid="post-congela-mesi" />
          <span className="text-sm text-muted-foreground">mesi</span>
        </div>
        <Label htmlFor="post-congela-scadenza-custom" className="text-xs text-muted-foreground">Oppure una data specifica</Label>
        <Input id="post-congela-scadenza-custom" type="date" value={form.data_scadenza_custom}
          onChange={event => setForm(prev => ({ ...prev, data_scadenza_custom: event.target.value }))}
          data-testid="post-congela-data-custom" />
      </div>
      <div className="space-y-1">
        <Label htmlFor="post-congela-note">Note (facoltative)</Label>
        <Input id="post-congela-note" value={form.note}
          onChange={event => setForm(prev => ({ ...prev, note: event.target.value }))} data-testid="post-congela-note" />
      </div>
      <Button type="button" className="w-full" disabled={saving || !form.data || !quantitaValida || (!form.data_scadenza_custom && !(Number(form.mesi) >= 1 && Number(form.mesi) <= 12))}
        onClick={() => onConferma({ ...form, metodo })} data-testid="post-congela-conferma">
        {saving ? "Salvataggio..." : `${azione} e stampa`}
      </Button>
    </div>
  );
};